module.exports = __webpack_public_path__ + "img/VectorBlue.be7dbcee.svg";